import ldCover from 'ldcover';

export default class Modal {
    constructor(el){
        
        this.modal = new ldCover({
            root: el,
            resident: true
        });

        this.modal.on('toggle.on', () => {
            document.getElementsByTagName("body")[0].style['overflow'] = "hidden";
        });
                
        this.modal.on('toggle.off', () => {
            document.getElementsByTagName("body")[0].style['overflow'] = "auto";
        });
    }

    get() {
        return this.modal;
    }
}

let filterModal,
    cartModal;

if(null != document.getElementById('filterModal')) {
    
    filterModal   = new Modal('#filterModal').get();
    console.log(filterModal);
}

if(null != document.getElementById('cartModal')) {
    cartModal     = new Modal('#cartModal').get();
}


window.callModal = (el) => {

    if(el == 'filter' && filterModal)
        filterModal.toggle();

    if(el == 'cart' && cartModal)
        cartModal.toggle();    
}